import script from "./sport-live-tv-scores-toggle.vue?vue&type=script&setup=true&lang=js"
export * from "./sport-live-tv-scores-toggle.vue?vue&type=script&setup=true&lang=js"

import "./sport-live-tv-scores-toggle.vue?vue&type=style&index=0&id=5d662462&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d662462"]])

export default __exports__